import script from "./GridChartEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./GridChartEditor.vue?vue&type=script&setup=true&lang=js"

import "./GridChartEditor.vue?vue&type=style&index=0&id=87be7ed2&lang=css"

const __exports__ = script;

export default __exports__